export default __webpack_public_path__ + "static/media/gallery - prince vs clean_04.4fcce6e0.jpg";